import axios from "axios";
import { toast } from "sonner";

export const appsApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/apps`, withCredentials: true });

const STATUS_HINTS = {
  401: "Your sign-in has expired. Sign in again and retry.",
  403: "Your account doesn't have permission to do this (admins only).",
  404: "The server couldn't find what was requested — it may have been removed or the session expired.",
  408: "The request timed out before the server received it all.",
  413: "The server rejected the request because it was too large to send in one go.",
  429: "Too many attempts. Wait a few minutes and try again.",
  500: "The server hit an internal error while processing this.",
  502: "The server or file storage didn't respond properly (bad gateway).",
  503: "The server is temporarily unavailable — it may be restarting.",
  504: "The server took too long to respond (gateway timeout).",
};

export const errMsg = (err, action = "") => {
  const prefix = action ? `${action} failed: ` : "";
  if (!err?.response) {
    if (err?.code === "ECONNABORTED") return `${prefix}the connection timed out. Check your internet connection and try again.`;
    return `${prefix}couldn't reach the server (network error or connection dropped${err?.message ? ` — ${err.message}` : ""}). Check your internet connection and try again.`;
  }
  const { status, statusText } = err.response;
  const d = err.response.data?.detail;
  let detail = "";
  if (typeof d === "string") detail = d;
  else if (Array.isArray(d)) detail = d.map((e) => `${(e?.loc || []).slice(-1)[0] ?? "field"}: ${e?.msg ?? ""}`).join("; ");
  const hint = STATUS_HINTS[status] ?? "The server returned an unexpected response.";
  return `${prefix}${detail || hint} (HTTP ${status}${statusText ? ` ${statusText}` : ""})`;
};

export const notifyError = (msg) => toast.error(msg, { duration: 30000, closeButton: true });

export const fmtSize = (n) => {
  const v = Number(n) || 0;
  if (v >= 1048576) return `${(v / 1048576).toFixed(1)} MB`;
  if (v >= 1024) return `${Math.round(v / 1024)} KB`;
  return `${v} B`;
};

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const inputCls = "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3.5 text-base text-ink outline-none transition-colors focus:border-sky-600";
export const btnDark = "inline-flex items-center justify-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-medium text-white transition-colors hover:bg-sky-700 disabled:opacity-60";
